/**
 * @description 事件处理器，做了一层封装，不给外面那么多东西
 * @author duanjun
 */

import { EventEmitter } from 'events';

export class EventEmitterWrapper {
    private $$eventEmitter: EventEmitter = new EventEmitter();
    constructor() {
        //
    }
    public on(eventName: string | symbol, listener: (...args: any[]) => void) {
        this.$$eventEmitter.on(eventName, listener);
    }

    public off(eventName?: string | symbol, listener?: (...args: any[]) => void) {
        if (eventName && listener) {
            this.$$eventEmitter.removeListener(eventName, listener);
        }
        if (!listener) {
            this.$$eventEmitter.removeAllListeners(eventName);
        }
    }

    public once(eventName: string | symbol, listener: (...args: any[]) => void) {
        this.$$eventEmitter.once(eventName, listener);
    }

    public emit(eventName: string | symbol, ...args: any[]) {
        this.$$eventEmitter.emit(eventName, ...args);
    }
}
